import httpClient from './httpClient'

const END_POINT = '/api/personas'

const postPersona = (data) => httpClient.post(END_POINT, data)
const putPersona = (id,data) => httpClient.put(`${END_POINT}/${id}`, data)
const checkPersonaReferencia = (codigo) => httpClient.get(`${END_POINT}/${codigo}`)
const getPersonas = async (search) => httpClient.get(`${END_POINT}/intranet`, { params: { pagination: false, queryString: search } })
const getFicha = async (idPersona) => httpClient.get(`${END_POINT}/get-ficha`, { params: {idPersona} })
 
export {

    postPersona,
    putPersona,
    checkPersonaReferencia,
    getPersonas,
    getFicha
}